// The Contentful `unit.pageDisplayType` toggle is a Boolean field with custom
// labels: `lessonPage` (true) renders the flattened link-summaries cards, and
// `lessonAccordion` (false) renders the legacy accordion tree driven by the
// `lessons` field.
export const PAGE_DISPLAY_TYPE = {
  ACCORDION: false,
  PAGE: true,
}
